import { createContext, useContext } from 'react'
import type { StorefrontResolvedTheme } from './types'
import { DEFAULT_UI, uiRootClasses } from './uiTokens'

/** Safe default so components like Button work outside a full ThemeProvider (e.g. account pages). */
const DEFAULT_THEME: StorefrontResolvedTheme = {
  id: 'reference',
  tokens: {},
  components: {
    button: 'btn-solid',
    card: 'card-soft',
    input: 'input-modern',
  },
  layout: { spacing: 'comfortable', density: 'relaxed' },
  ui: DEFAULT_UI,
  rootClassName:
    `sf-theme-reference ${uiRootClasses(DEFAULT_UI)} sf-density-relaxed sf-input-modern`.trim(),
  cssVars: {},
}

const ThemeContext = createContext<StorefrontResolvedTheme | null>(null)

export function ThemeProvider({
  theme,
  children,
}: {
  theme: StorefrontResolvedTheme
  children: React.ReactNode
}) {
  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export function useTheme(): StorefrontResolvedTheme {
  return useContext(ThemeContext) ?? DEFAULT_THEME
}

